module.exports = __webpack_public_path__ + "img/quick_b2.70d233df.jpg";